import {
  AfterViewChecked,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { DynamicStats, EmcOptions } from '../../../models/entity-model-customization.model';
import { SubstationService } from '../../../services/substation.service';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { Filter } from '../../../models/dynamic-filter.model';
import { EMCType } from '../../../enums/emc-type';
import { TaggedSubstationService } from '../../../services/tagged-substation.service';
import { EquipmentListService } from '../../../services/equipment-list.service';
import { BuildingService } from '../../../services/building.service';
import { CustomerService } from '../../../services/customer.service';
import { PoleService } from '../../../services/pole.service';

@Component({
  selector: 'lib-dynamic-cards',
  standalone: false,
  templateUrl: './dynamic-cards.component.html',
  styleUrls: ['./dynamic-cards.component.scss'],
})

export class DynamicCardsComponent implements OnChanges, AfterViewChecked {
  @Input() emcOptions: EmcOptions[] = [];
  @Input() filter : Filter = new Filter();
  @Input() entityType: EMCType = EMCType.InjectionSubstation;
  cardValues: Record<string, number> = {};

  constructor(
    private substationService: SubstationService,
    private taggedSubstationService: TaggedSubstationService,
    private equipmentListService: EquipmentListService,
    private buildingService: BuildingService,
    private customerService: CustomerService,
    private poleService: PoleService,
  ) {}

  refresh(): void {
    if (!this.emcOptions?.length) return;

    this.cardValues = {};

    this.emcOptions.forEach((opt, index) => {
      const key = index;
      const obj = new DynamicStats(opt, this.filter);

      if (this.entityType == EMCType.InjectionSubstation) {
        this.substationService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      } else if(this.entityType == EMCType.SubstationTemplate) {
        this.taggedSubstationService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      } else if (this.entityType == EMCType.EquipmentTemplate) {
        this.equipmentListService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      } else if (this.entityType == EMCType.Building) {
        this.buildingService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      } else if (this.entityType == EMCType.Customer) {
        this.customerService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      } else if (this.entityType == EMCType.Pole) {
        this.poleService.getStatsDynamic(obj).subscribe(
          (value) => {
            this.cardValues[key] = value.body?.data ?? 0;
          },
          () => {
            this.cardValues[key] = 0;
          },
        );
      }
    });
  }

  ngOnChanges(): void {
    this.refresh();
  }
  private swiperInitialized = false;

  ngAfterViewChecked(): void {
    if (this.swiperInitialized || !this.emcOptions.length) return;
    this.swiperInitialized = true;
    

    Swiper.use([Navigation, Pagination]);
    new Swiper('.slide-container', {
      slidesPerView: 6,
      spaceBetween: 10,
      loop: false,
      grabCursor: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        0: { slidesPerView: 1 },
        520: { slidesPerView: 2 },
        950: { slidesPerView: 3 },
        1200: { slidesPerView: 5 },
      },
    });
  }
}
